import "../assets/sprite-sheet.svg";
import {
  Cloud,
  Drizzle,
  DrizzleSun,
  DrizzleThunder,
  DrizzleThunderSun,
  ErrorNoMatchingIcon,
  Fog,
  HeavySleet,
  HeavySleetSun,
  HeavySleetThunder,
  HeavySleetThunderSun,
  HeavySnow,
  HeavySnowSun,
  HeavySnowThunder,
  HeavySnowThunderSun,
  LightCloud,
  LightRain,
  LightRainSun,
  LightRainThunder,
  LightRainThunderSun,
  LightSleet,
  LightSleetSun,
  LightSleetThunder,
  LightSleetThunderSun,
  LightSnow,
  LightSnowSun,
  LightSnowThunder,
  LightSnowThunderSun,
  PartlyCloud,
  Rain,
  Raindrops,
  RainSun,
  RainThunder,
  RainThunderSun,
  Sleet,
  SleetSun,
  SleetSunThunder,
  SleetThunder,
  Snow,
  SnowSun,
  SnowSunThunder,
  SnowThunder,
  Sun,
  Wind,
} from "./icons/index";

const icons = {
  Cloud,
  Drizzle,
  DrizzleSun,
  DrizzleThunder,
  DrizzleThunderSun,
  ErrorNoMatchingIcon,
  Fog,
  HeavySleet,
  HeavySleetSun,
  HeavySleetThunder,
  HeavySleetThunderSun,
  HeavySnow,
  HeavySnowSun,
  HeavySnowThunder,
  HeavySnowThunderSun,
  LightCloud,
  LightRain,
  LightRainSun,
  LightRainThunder,
  LightRainThunderSun,
  LightSleet,
  LightSleetSun,
  LightSleetThunder,
  LightSleetThunderSun,
  LightSnow,
  LightSnowSun,
  LightSnowThunder,
  LightSnowThunderSun,
  PartlyCloud,
  Rain,
  Raindrops,
  RainSun,
  RainThunder,
  RainThunderSun,
  Sleet,
  SleetSun,
  SleetSunThunder,
  SleetThunder,
  Snow,
  SnowSun,
  SnowSunThunder,
  SnowThunder,
  Sun,
  Wind,
};

function WeatherSymbol({ symbolName, rotateDegree, size = "4rem" }) {
  const CurrentIcon = icons?.[symbolName] || icons.ErrorNoMatchingIcon;
  const isWind = symbolName === "Wind";
  // const CurrentIcon = icons?.[symbolName] || icons.ErrorNoMatchingIcon;
  return (
    <>
      {/* <div className="weather-symbol"> */}
      <CurrentIcon
        style={{
          transform: isWind && `rotate(${rotateDegree}deg) scale(-1,-1)`,
          height: size,
        }}
      />
      {/* </div> */}
      {/* <p>{symbolName}</p> */}
    </>
  );
}

export default WeatherSymbol;
